import { isEqual } from 'lodash-es';

/**
 * @returns {any}
 */
const kformCheckboxDirective = /* @ngInject */ () => ({
	restrict: 'A',
	require:  'ngModel',
	scope: {
		options: '<kformCheckbox',
	},
	/**
	 * @param {any} scope
	 * @param {any} element
	 * @param {import('angular').IAttributes} _
	 * @param {import('angular').INgModelController} ctrl
	 */
	link(scope, element, _, ctrl) {
		const trueValue = scope.options.component.trueValue ?? true;
		const falseValue = scope.options.component.falseValue ?? false;
		const { data } = scope.options;

		element.on('change', (/** @type {Event} */ event) => {
			ctrl.$setViewValue(element[0].checked, event?.type);
		});

		ctrl.$render = () => {
			element[0].checked = ctrl.$viewValue;
		};

		// Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
		// This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
		// it to a boolean.
		ctrl.$isEmpty = (/** @type {any} */ value) => value === false;

		ctrl.$formatters.push((/** @type {any} */ value) => isEqual(value, trueValue));

		ctrl.$parsers.push((/** @type {any} */ value) => value ? trueValue : falseValue);

		if (data === true) {
			element[0].checked = true;
		}

		ctrl.$setViewValue(element[0].checked);
		ctrl.$validate();
	},
});

export default kformCheckboxDirective;
